export default __webpack_public_path__ + "locales/ro/Errors.json?hash=6fcc6cc30caeee5cdb3faa898815aca5";